import { list } from 'https://cdn.venturz.co/lib/redom.es.js';

class GroupInputsRenderer {

  renderInput() {

    this.input = list('div.group-input-options-container', this.Option, null, this);

    return this.input;

  }

  update(inputOptions, fieldRow) {

    this.inputOptions = inputOptions;

    this.input.update(inputOptions.options, { type: 'default', value: fieldRow });

  }

  trySetRequired() {

    if (this.inputOptions.required !== true) {
      return;
    }

    this.input.update(this.inputOptions.options, { type: 'setRequired', value: true });

  }

  tryUnsetRequired() {

    if (this.inputOptions.required !== true) {
      return;
    }

    this.input.update(this.inputOptions.options, { type: 'setRequired', value: false });

  }

}

export default GroupInputsRenderer;